import React from "react";
import { Helmet } from "react-helmet";
import '../index.css';
import CanonicalTag from "../components/CanonicalTag";

import cement from '../assets/Images/cement_thumb.jpg';
import vertical from '../assets/Images/vertical ball mill.jpg';
import belt from '../assets/Images/belt conveyors  2.jpg';
import simplex from '../assets/Images/SIMPLEX_Bucket_Elevator_WEBSITE.jpg';

const Rawmill = () => {
  return (
    <>
      {/* SEO Meta & Canonical */}
    <Helmet>
  <title>Raw Mill & Conveyor Equipment Manufacturer | Cement Plant Machinery | Valerion Impex</title>

  <meta
    name="description"
    content="Valerion Impex manufactures and supplies premium raw mill equipment, belt conveyors, screw conveyors, bucket elevators and cement plant machinery for efficient material handling and cement production."
  />

  <meta
    name="keywords"
    content="raw mill equipment, raw mill manufacturer, cement raw mill, belt conveyor, screw conveyor, bucket elevator, conveyor equipment, cement plant machinery, cement machinery parts, material handling equipment, cement plant equipment, industrial conveyors, conveyor manufacturer India, raw mill spare parts, Valerion Impex"
  />
</Helmet>


      <CanonicalTag url="https://www.cementmachineryparts.in/products/raw-mill" />

      <div className="container">
        <h1 className="raw-mill-title bg-dark text-white cement-raw text-center mt-3 py-2 mx-auto mb-3">
          Raw Mill & Conveyors Equipments
        </h1>

        <p className="fs-1 text-center text-primary"><b>RAW MILL</b></p>
        <p className="text-center fs-5">
          Raw mill is called cement raw mill, raw mill in cement plant, it refers to a common type of cement equipment in the Cement Plant.
          In the cement manufacturing process, raw mill in cement plant grind cement raw material into the raw mix, and the raw mix is sent to the cement kiln to make cement clinker,
          clinker and other admixtures will be ground into finished cement by cement mill.
        </p>
        <p className="text-center"><b> TWO TYPES OF RAW MILL </b></p>

        {/* Section 1: Image Left, Text Right */}
        <div className="row align-items-center mb-2">
          <div className="col-sm-12 col-lg-6">
            <img src={cement} alt="cement" className="img-fluid rawmill" />
          </div>
          <div className="col-sm-12 col-lg-6 px-5 my-3">
            <p><b>Application:</b> Limestone, clay, coal, iron ore, copper, phosphate</p>
            <p><b>Capacity:</b> 0.65-615 T/H</p>
            <p><b>Advantage:</b><br />
              High output<br />
              Safe and Reliable System<br />
              Good wear resistance and long service life
            </p>
          </div>
        </div>

        {/* Section 2: Text Left, Image Right */}
        <div className="row align-items-center mb-2">
          <div className="col-sm-12 col-lg-6 my-2 order-lg-1 order-2 px-5">
            <p><b>Application:</b> Limestone, Clay, graphite, phosphate</p>
            <p><b>Capacity:</b> 13-70t/h</p>
            <p><b>Advantage:</b><br />
              Low investment<br />
              Low operation Cost<br />
              Environment protection Clean
            </p>
          </div>
          <div className="col-sm-12 col-lg-6 order-lg-2 order-1 px-5">
            <img src={vertical} alt="vertical" className="img-fluid rawmill verticalshaft" />
          </div>
        </div>

        {/* Conveyors Equipments Title */}
        <div className="row align-items-center">
          <h3 className="bg-dark text-white cement-raw text-center py-2">
            We are always committed to delivering the best quality items to our customers at industry leading prices
          </h3>
          <p className="text-center fs-2 text-primary"><b>Conveyors Equipments</b></p>

          {/* Belt Conveyor - Image Left, Text Right */}
          <div className="col-sm-12 col-lg-6 order-lg-1 order-2 mt-3">
            <img src={belt} alt="belt conveyor" className="img-fluid" />
          </div>
          <div className="col-sm-12 col-lg-6 order-lg-2 order-1">
            <p><b>Rubber Belt width:</b> 400-2400mm</p>
            <p><b>Conveying Capacity:</b> 30-3000t/h</p>
            <p><b>Application:</b> Widely used for Transportation of various lumpy, granular, and powdery materials</p>
            <p>
              Cement conveyor refers to a belt conveyor in cement plant, which is necessary accessory equipment in the cement production line.
              Belt conveyor is a material handling equipment with strong adaptability, apply for conveying bulk density less than 1.67t/m³.
              It is mostly used for powder, granular, small lump materials and bagged materials such as sand, ore, coal, cement and other loose materials.
            </p>
          </div>
        </div>

        {/* Bucket Elevator - Text Left, Image Right */}
        <div className="row align-items-center mt-4 px-5">
          <div className="col-sm-12 col-md-6">
            <p><b>Lifting Height:</b> 28-80m</p>
            <p><b>Conveying Capacity:</b> 3-491m³/h</p>
            <p><b>Application:</b> Coal, Cement, Stone, Sand, Clay, Ore</p>
            <p>
              Bucket elevator in cement plant, also called cement bucket elevator, is mechanical conveying equipment, apply for the vertical lift of powder, particles like limestone, coal, gypsum, clinker, clay, raw meal, cement, pulverized coal, etc.
              In general, cement bucket elevator works with cement crusher, raw mill, cement mill, and other cement equipment.
            </p>
          </div>
          <div className="col-sm-12 col-md-6 position-relative">
            <img src={simplex} alt="bucket elevator" className="img-fluid verticalshaft" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Rawmill;
